import React, { useEffect, useState } from 'react'
import './onlinefriend.css'

const OnlineFriend = ({id}) => {

      const [onlineFriend, setOnlineFriend] = useState([])

      async function getOnlineFriend(id_xat){

            const url = `https://oceanbot.net/online.php?id=${id_xat}`

            try{
                  const response = await fetch(url)
                  const result = await response.json()
                  setOnlineFriend(result)
            }
            catch(err){
                  console.log(err)
            }

      }

      id = id.replace('M', '000000')
      
      useEffect(() => {
            if(id.length !== 0){
                  getOnlineFriend(id)
            }
      }, [id])

      if(id.length === 0) return 

      return (
            <div className="online_friend">
                  <div className={onlineFriend.status === 'online' ? "dot_frient green" : "dot_frient red"}></div>
            </div>
      )
}

export default OnlineFriend
